import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=5bc2bc54&scoped=true&"
import script from "./UpdateDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDialog.vue?vue&type=style&index=0&id=5bc2bc54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2bc54",
  null
  
)

export default component.exports